import {
    ApplicationConfig,
    provideExperimentalZonelessChangeDetection,
    importProvidersFrom,
    ErrorHandler,
    provideAppInitializer,
    inject
} from "@angular/core";
import { provideRouter } from "@angular/router";
import { provideHttpClient, withFetch, withInterceptors } from "@angular/common/http";
import { provideAnimations } from "@angular/platform-browser/animations";
import { withPreloading } from "@angular/router";
import { provideLottieOptions } from "ngx-lottie";
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from "../environments/environment";

import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';

import { routes } from "./app.routes";
import { authInterceptor } from "./interceptors/auth.interceptor";
import { createErrorHandler, TraceService } from "@sentry/angular";
import { CustomQuicklinkStrategy } from "./services/custom-quicklink.service";

export const appConfig: ApplicationConfig = {
    providers: [
        provideExperimentalZonelessChangeDetection(),
        provideRouter(routes, withPreloading(CustomQuicklinkStrategy)),
        provideHttpClient(
            withFetch(),
            withInterceptors([authInterceptor])
        ),
        provideAnimations(),
        provideAnimationsAsync(),
        provideLottieOptions({
            player: () => import("lottie-web"),
        }),
        providePrimeNG({
            theme: {
                preset: Aura,
                options: {
                    // prefix: '.prime',
                    // selector: '.prime-theme',
                    darkModeSelector: ''
                }
            },
        }),
        {
            provide: ErrorHandler,
            useValue: createErrorHandler(),
        },
        // // sentry tracing disabled
        // provideAppInitializer(() => {
        //     inject(TraceService);
        // }),
    ],
};
